import { cloneDeep } from 'lodash-es'
import {
  countryOptions,
  locationTypeOptions,
  roleOptions,
  stateOptions,
} from 'src/config/options'
import { centerFinancialTemplate } from './center'

export const basePersonTemplate = {
  preferredName: '',
  firstName: '',
  middleName: '',
  lastName: '',
}

export const nameWithDescTemplate = {
  name: '',
  description: '',
}

export const customFieldTemplate = {
  fieldName: '',
  fieldValue: '',
}

export const addressTemplate = {
  address: '',
  city: '',
  state: stateOptions.CA[0].value,
  country: countryOptions[0].value,
  postalCode: '',
  phoneNumber: '',
  emailAddress: '',
}

export const baseAddressTemplate = {
  address: '',
  city: '',
  state: stateOptions.CA[0].value,
  country: countryOptions[0].value,
  postalCode: '',
}

export const locationTemplate = {
  id: '',
  name: '',
  address: '',
  city: '',
  state: stateOptions.CA[0].value,
  country: countryOptions[0].value,
  timeZone: 'MST',
  openTime: '06:00:00',
  closeTime: '18:00:00',
  phoneNumber: '',
  postalCode: '',
  type: locationTypeOptions[0],
  centerBankAccount: cloneDeep(centerFinancialTemplate),
  enableAttendanceKiosk: false,
  setupMode: true,
  isOvernight: false,
  enableIncidentAcknowledgment: false,
  enableParentToRoomStaffMessaging: false,
  schedule: {
    openDate: '',
    closeDate: '',
    recurringDays: {},
    customDays: {},
  },
  monthlyFees: {
    padPercentage: 1,
    padFixed: 0.3,
    creditCardPercentage: 3.75,
    creditCardFixed: 0.3,
  },
  monthlyParentFees: {
    padPercentage: 0,
    padFixed: 0,
    creditCardPercentage: 0,
    creditCardFixed: 0,
  },
}

export const adjustmentTemplate = {
  name: '',
  percentage: null,
  fixedAmount: null,
  isFee: false,
  isMealService: false,
  outsideProgram: false,
}

export const sponsorTemplate = {
  id: '',
  name: '',
  email: '',
  hiddenOnPortal: false,
  centerIds: null as string[] | null,
}

export const preauthorizedDebitTemplate = {
  bankName: '',
  institutionNumber: '',
  transitNumber: '',
  accountNumber: '',
  isAutoPayment: true,
}

export const financialTemplate = {
  preauthorizedDebit: cloneDeep(preauthorizedDebitTemplate),
}

export const userTemplate = {
  firstName: '',
  lastName: '',
  email: '',
  role: roleOptions[1].value,
  centerId: '',
  multipleCenterIds: [] as string[],
  dateOfBirth: '',
  contactInfo: cloneDeep(addressTemplate),
}

export const orgTemplate = {
  id: '',
  orgInfo: {
    orgAlias: '',
    logo: '',
    language: 'en-US',
    currency: 'CAD',
    name: '',
    address: '',
    city: '',
    state: '',
    phoneNumber: '',
    country: '',
    postalCode: '',
    type: '',
    token: '',
  },
}
